import styled from 'styled-components';
export const IconHolder = styled.section`
  text-align: center;
  margin-bottom: 30px;
`;